import {
  websiteMeetsIntegrationPlanTier,
  integrationUpgradePlan,
} from "utils/integrationPlanAccess";
import {
  isTargetedEmbedsGated,
  targetedEmbedsUpgradePlan,
} from "utils/targetedEmbedsAccess";

function readIntegrationGateContext() {
  var modal = $("#upgrade");
  return {
    planType: modal.attr("data-plan-type") || window.plan_type,
    websitePremium: modal.attr("data-website-premium"),
    websitePlan: modal.attr("data-website-plan"),
  };
}

function hardGateIntegrationOptionToggle(
  $checkbox,
  message,
  upgradePlan,
  eventType
) {
  var checkboxId = $checkbox.attr("id") || "";
  var hiddenId = checkboxId.replace(/_checkbox$/, "");
  var $hidden = hiddenId ? $("#" + hiddenId) : $();
  var $toggle = checkboxId
    ? $("#" + checkboxId.replace(/_checkbox$/, "_switch"))
    : $();
  var integrationType = $checkbox.data("integration-type") || "integration";

  var isEnabled = function () {
    if ($hidden.length && String($hidden.val()) === "true") {
      return true;
    }
    return $checkbox.is(":checked");
  };

  var setDisabled = function () {
    $checkbox.prop("checked", false).removeClass("green");
    if ($hidden.length) {
      $hidden.val("false");
    }
  };

  var onToggleClick = function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    // Grandfathered on: allow turning off without an upgrade modal.
    if (isEnabled()) {
      setDisabled();
      return;
    }

    // Off + gated: block enabling and prompt to upgrade.
    setDisabled();
    subscriptions.upgrade_modal(
      e,
      false,
      message,
      upgradePlan,
      eventType.replace("{integration}", integrationType)
    );
  };

  if ($toggle.length) {
    $toggle
      .removeAttr("onclick")
      .off("click.integrationOptionGate")
      .on("click.integrationOptionGate", onToggleClick);
  }

  $checkbox
    .off("change.integrationOptionGate click.integrationOptionGate")
    .on(
      "change.integrationOptionGate click.integrationOptionGate",
      onToggleClick
    );
}

// Safe to re-run after lazy-loaded integration modals / option managers.
// Only binds contact_push / contact_fetch toggles (namespaced off/on).
function bindIntegrationOptionGates(root) {
  var $root = root ? $(root) : $(document);
  var ctx = readIntegrationGateContext();
  var planType = ctx.planType;
  var websitePremium = ctx.websitePremium;
  var websitePlan = ctx.websitePlan;

  if (
    $.inArray(planType, [
      "free",
      "2026_personal",
      "2026_prime",
      "2024_pages",
      "2024_core",
      "2024_funnels",
    ]) > -1 ||
    websitePremium == "false"
  ) {
    $root.find("input[data-name*='contact_fetch']").each(function () {
      hardGateIntegrationOptionToggle(
        $(this),
        "enable identity resolution for integrations",
        "pro",
        "Triggered feature CTA – Targeting – {integration}"
      );
    });
  }

  $root.find("input[data-name*='contact_push']").each(function () {
    var $checkbox = $(this);
    var planTier = $checkbox.data("plan-tier") || "pro";
    var canUseContactPush = websiteMeetsIntegrationPlanTier({
      planType: websitePlan || planType,
      websitePremium: websitePremium,
      planTier: planTier,
    });

    if (canUseContactPush) {
      return;
    }

    hardGateIntegrationOptionToggle(
      $checkbox,
      "automatically sync contacts to integrations",
      integrationUpgradePlan(planTier),
      "Triggered feature CTA – Contact Push – {integration}"
    );
  });
}

var feature_gates = function () {
  var modal = $("#upgrade");
  var plan = $(modal).attr("data-plan");
  window.plan_type = $(modal).attr("data-plan-type");
  var plan_interval = $(modal).attr("data-plan-interval");
  var partner_type = $(modal).attr("data-partner-type");
  var website_premium = $(modal).attr("data-website-premium");
  var website_plan = $(modal).attr("data-website-plan");
  var account_plan_type = $(modal).attr("data-plan-type");
  var is_2024_customer =
    String(account_plan_type || "").indexOf("2024") > -1 ||
    String(website_plan || "").indexOf("2024") > -1;
  var cta_count = $(modal).attr("data-cta-count");
  var after_2024_deprecated =
    $(modal).attr("data-account-after-2024-deprecation") == "true";
  var admin_type = $(modal).attr("data-admin-type");
  var remix_ai_plan = is_2024_customer ? "remix" : "pro";

  // limit account features
  if (plan_type) {
    $(".upgrade-button").on("click", function (e) {
      if ($(e.target).is("a") == false || $(this).hasClass("upgrade-button")) {
        if (
          website_premium == "false" ||
          [
            "free",
            "2026_personal",
            "2026_prime",
            "2024_pages",
            "2024_core",
            "2024_funnels",
          ].includes(plan_type)
        ) {
          subscriptions.upgrade_modal(
            event,
            false,
            "unlock pro features for the funnel builder.",
            "pro",
            "Triggered feature CTA – Paid Features"
          );
        }
      }
    });

    $(".upgrade-plus-button").on("click", function (e) {
      if (
        $(e.target).is("a") == false ||
        $(this).hasClass("upgrade-plus-button")
      ) {
        if (
          website_premium == "false" ||
          [
            "free",
            "2026_personal",
            "2026_prime",
            "2026_pro",
            "2025_pro",
            "2024_pages",
            "2024_core",
            "2024_funnels",
            "2024_pro",
          ].includes(plan_type)
        ) {
          subscriptions.upgrade_modal(
            event,
            false,
            "unlock Plus features.",
            "plus",
            "Triggered feature CTA – Paid Features"
          );
        }
      }
    });

    if (
      ["free"].includes(plan_type) ||
      website_premium == "false" ||
      is_2024_customer
    ) {
      $(".remix-create").on("click", function (e) {
        subscriptions.upgrade_modal(
          e,
          false,
          "have Remix AI to build funnels for you.",
          remix_ai_plan,
          "Triggered feature CTA – Remix AI",
          false,
          "x3rs6cvrwi"
        );
      });
    }

    // Experiment recommendations chat is not gated on open — Duplicate & Remix
    // / actions budget gates still apply when applying a recommendation.

    $(".upgrade-remix-ai-button").on("click", function (e) {
      subscriptions.upgrade_modal(
        e,
        false,
        "use Remix AI to build funnels for you.",
        remix_ai_plan,
        "Triggered feature CTA – Remix AI",
        false,
        "x3rs6cvrwi"
      );
    });

    $(".landing-pages-launch").on("click", function (e) {
      e.preventDefault();
      subscriptions.upgrade_modal(
        e,
        false,
        "host landing pages on ConvertFlow",
        "paid",
        "Triggered feature CTA – Landing Pages"
      );
    });

    if (plan_type == "free") {
      $(".affiliate-program").on("click", function (event) {
        subscriptions.upgrade_modal(
          event,
          false,
          "join the affiliate partner program",
          "partner",
          "Triggered feature CTA – Partner"
        );
      });
    }

    if (["agency", "affiliate"].includes(partner_type) == false) {
      $(".partner-program").on("click", function (event) {
        event.preventDefault();
        subscriptions.upgrade_modal(
          event,
          false,
          "join the affiliate partner program",
          "partner",
          "Triggered feature CTA – Partner"
        );
      });
    }

    if (
      [
        "free",
        "2026_personal",
        "2026_prime",
        "2026_pro",
        "2025_pro",
        "2024_pages",
        "2024_core",
        "2024_funnels",
        "2024_pro",
      ].indexOf(plan_type) > -1
    ) {
      $("#accounts-logo-upload").on("click", function (event) {
        subscriptions.upgrade_modal(
          event,
          false,
          "add custom branding to your account",
          "plus",
          "Triggered feature CTA – Branded Account"
        );
      });
    }

    // limit website features

    // override 2024+ account plan with websites plan if website on lesser plan
    if (
      plan_type.indexOf("2026") > -1 ||
      plan_type.indexOf("2025") > -1 ||
      plan_type.indexOf("2024") > -1
    ) {
      if (website_premium == "false") {
        window.plan_type = "free";
      }
      if (website_premium == "true" && website_plan) {
        window.plan_type = website_plan;
      }
    }

    // Advanced personalization features unlock on 2026 Pro (Plus on older plan generations)
    var advancedFeatureUpgradePlan =
      String(window.plan_type || "").indexOf("2026") > -1 ? "pro" : "plus";

    $(".upgrade-website-button").on("click", function (e) {
      if (
        $(e.target).is("a") == false ||
        $(this).hasClass("upgrade-website-button")
      ) {
        if (plan_type == "free" || website_premium == "false") {
          subscriptions.upgrade_modal(
            event,
            false,
            "go live on your own website and unlock pro features.",
            plan.indexOf("enterprise") > -1 ? "plus" : "pro",
            "Triggered feature CTA – Paid Features"
          );
        }
      }
    });

    if (plan_type == "free" || website_premium == "false") {
      setTimeout(function () {
        $('select[name="cta[domain_id]"]').on("change", function (e) {
          // Free / non-premium sites can publish to Shopify pages without upgrading
          if ($(this).val() === "Shopify") {
            return;
          }

          e.preventDefault();
          subscriptions.upgrade_modal(
            event,
            false,
            "go live on your own domain",
            "pro",
            "Triggered feature CTA – Paid Features"
          );
        });
      }, 100);
    }

    if (
      (plan_type == "free" || website_premium == "false") &&
      cta_count &&
      parseInt(cta_count) >= 3
    ) {
      document.addEventListener(
        "click",
        function (e) {
          if (e.target.closest && e.target.closest(".new-cta")) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            subscriptions.upgrade_modal(
              e,
              false,
              "create more than 3 funnel campaigns",
              "paid",
              "Triggered feature CTA – CTA Limit"
            );
          }
        },
        true
      ); // true = capture phase
    }

    if (
      ["2024_pages"].includes(plan_type) &&
      website_premium != "false" &&
      cta_count &&
      parseInt(cta_count) >= 5
    ) {
      document.addEventListener(
        "click",
        function (e) {
          if (e.target.closest && e.target.closest(".new-cta")) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            subscriptions.upgrade_modal(
              e,
              false,
              "create more than 5 funnel campaigns",
              "pro",
              "Triggered feature CTA – CTA Limit"
            );
          }
        },
        true
      ); // true = capture phase
    }

    if (
      ["2026_prime"].includes(plan_type) &&
      website_premium != "false" &&
      cta_count &&
      parseInt(cta_count) >= 25
    ) {
      document.addEventListener(
        "click",
        function (e) {
          if (e.target.closest && e.target.closest(".new-cta")) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            subscriptions.upgrade_modal(
              e,
              false,
              "create more than 25 funnel campaigns",
              "pro",
              "Triggered feature CTA – CTA Limit"
            );
          }
        },
        true
      ); // true = capture phase
    }

    $("#remix_all_text_container").on("click", function (e) {
      if (
        e.target.closest &&
        e.target.closest("#remix_all_text_switch") &&
        !admin_type &&
        ($(this).attr("data-beta") !== "true" || website_premium == "false")
      ) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        subscriptions.upgrade_modal(
          e,
          false,
          "use remix AI to generate a template",
          remix_ai_plan,
          "Triggered feature CTA – Remix AI",
          false,
          "x3rs6cvrwi"
        );
      }
    });

    if (
      ["2026_personal", "2024_core", "2024_funnels", "2023_build"].includes(
        plan_type
      ) &&
      website_premium != "false" &&
      cta_count &&
      parseInt(cta_count) >= 10
    ) {
      document.addEventListener(
        "click",
        function (e) {
          if (e.target.closest && e.target.closest(".new-cta")) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            subscriptions.upgrade_modal(
              e,
              false,
              "create more than 10 funnel campaigns",
              "pro",
              "Triggered feature CTA – CTA Limit"
            );
          }
        },
        true
      ); // true = capture phase
    }

    if (plan_type == "free" || website_premium == "false") {
      $(".domain-create").on("click", function () {
        subscriptions.upgrade_modal(
          event,
          false,
          "add custom domains for landing pages",
          "pro",
          "Triggered feature CTA – Custom Domain"
        );
      });
    }

    if (
      ["free", "2026_personal", "2024_pages"].includes(plan_type) ||
      website_premium == "false"
    ) {
      $(".variant-create").on("click", function (e) {
        $("#newVariant").modal("hide");
        $("#newVariant").remove();

        subscriptions.upgrade_modal(
          event,
          false,
          "create and manage variants for A/B split-tests",
          "pro",
          "Triggered feature CTA – Custom Domain"
        );
      });
    }

    if (plan_type == "free" || website_premium == "false") {
      $(".insights-link").on("click", function (e) {
        e.preventDefault();

        subscriptions.upgrade_modal(
          event,
          false,
          "get site-wide insights on your funnel performance and lead generation.",
          "paid",
          "Triggered feature CTA – Insights",
          false,
          "hqds0fxgj3"
        );
      });
    }

    if (
      $("body").attr("data-controller") == "websites" &&
      $("body").attr("data-action") == "insights"
    ) {
      if (plan_type == "free" || website_premium == "false") {
        subscriptions.upgrade_modal(
          event,
          false,
          "get site-wide insights on your funnel performance and lead generation.",
          "paid",
          "Triggered feature CTA – Insights",
          true,
          "hqds0fxgj3"
        );
      }
    }

    if (
      ["free", "2026_personal"].includes(plan_type) ||
      website_premium == "false"
    ) {
      $("#website_powered_by")
        .unbind("click")
        .on("click", function (event) {
          $("#website_powered_by").prop("checked", true);
          subscriptions.upgrade_modal(
            event,
            false,
            'remove "powered by" links',
            "pro",
            "Triggered feature CTA – Remove Powered By"
          );
        });
    }

    if (
      [
        "free",
        "2026_personal",
        "2026_prime",
        "2024_pages",
        "2024_core",
        "2024_funnels",
        "2023_build",
        "2023_launch",
      ].indexOf(plan_type) > -1 ||
      website_premium == "false"
    ) {
      $(
        "body[data-controller='broadcasts'], body[data-controller='playbooks']"
      ).on("click", ".broadcast-create", function (event) {
        $("#newEmptyBroadcastModal").remove();
        subscriptions.upgrade_modal(
          event,
          false,
          "create experiment campaigns",
          "pro",
          "Triggered feature CTA – Broadcasts"
        );
      });
    }

    $(".experiment-schedule-button").on("click", function (e) {
      if (
        $(e.target).is("a") == false ||
        $(this).hasClass("experiment-schedule-button")
      ) {
        if (
          website_premium == "false" ||
          ([
            "free",
            "2026_personal",
            "2026_prime",
            "2025_pro",
            "2024_pages",
            "2024_core",
            "2024_funnels",
            "2024_pro",
          ].includes(plan_type) &&
            !admin_type)
        ) {
          subscriptions.upgrade_modal(
            event,
            false,
            "schedule split-tests.",
            advancedFeatureUpgradePlan,
            "Triggered feature CTA – Multivariate Split-Testing"
          );
        }
      }
    });

    if (isTargetedEmbedsGated(plan_type, website_premium)) {
      $(document).on("click", ".area-new", function (event) {
        event.preventDefault();
        $("#areaModal").modal("hide");
        $("#areaModal").remove();
        subscriptions.upgrade_modal(
          event,
          false,
          "launch targeted embeds",
          targetedEmbedsUpgradePlan(plan_type),
          "Triggered feature CTA – Targeted Embeds"
        );
      });
    }

    if (
      $.inArray(plan_type, [
        "free",
        "2026_personal",
        "2026_prime",
        "2026_pro",
        "2025_pro",
        "2024_pages",
        "2024_core",
        "2024_funnels",
        "2024_pro",
        "2021_pro",
        "2022_pro",
        "2023_build",
        "2023_launch",
      ]) > -1 ||
      website_premium == "false"
    ) {
      $("input[data-name='segment-events']").on("change", function (e) {
        e.preventDefault();
        $(e.target).prop("checked", false);
        subscriptions.upgrade_modal(
          event,
          false,
          "send events stream to integrations",
          "plus",
          "Triggered feature CTA – Events Streaming"
        );
      });

      $("input[data-name*='segment']").each(function (i, input) {
        $(input).on("focus", function (e) {
          e.preventDefault();
          $(e.target).val("");
          subscriptions.upgrade_modal(
            event,
            false,
            "send events stream to integrations",
            "plus",
            "Triggered feature CTA – Events Streaming"
          );
        });
      });
    }

    bindIntegrationOptionGates();

    // Hard-gate connect for integrations that opt in (e.g. Shopify → Personal, Zapier → Prime).
    $(
      '.integration-item[data-hard-gate-connect="true"] .integration-connect, .integration-item[data-hard-gate-connect="true"] .api-connect'
    ).each(function () {
      var $button = $(this);
      var $item = $button.closest(".integration-item");
      var planTier = $item.attr("data-plan") || "personal";
      var service = $item.attr("data-service") || "integration";
      var canConnect = websiteMeetsIntegrationPlanTier({
        planType: website_plan || plan_type,
        websitePremium: website_premium,
        planTier: planTier,
      });

      if (canConnect) {
        return;
      }

      $button
        .removeAttr("onclick")
        .removeAttr("href")
        .removeAttr("data-toggle")
        .removeAttr("data-target")
        .off("click.integrationConnectGate")
        .on("click.integrationConnectGate", function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          subscriptions.upgrade_modal(
            e,
            false,
            "connect " + service,
            integrationUpgradePlan(planTier),
            "Triggered feature CTA – Integrations – " + service
          );
        });
    });

    // Hard-gate GA4 / dataLayer event streaming toggles to Plus.
    if (
      [
        "free",
        "2026_personal",
        "2026_prime",
        "2026_pro",
        "2025_pro",
        "2024_pages",
        "2024_core",
        "2024_funnels",
        "2024_pro",
      ].includes(plan_type) ||
      website_premium == "false"
    ) {
      var gateGaEventsToggle = function (
        toggleSelector,
        checkboxSelector,
        hiddenSelector,
        message
      ) {
        if (
          plan_type === "2024_pro" &&
          !after_2024_deprecated &&
          checkboxSelector === "#google-analytics-track"
        ) {
          return;
        }

        var $toggle = $(toggleSelector);
        var $checkbox = $(checkboxSelector);
        var $hidden = $(hiddenSelector);

        if (!$toggle.length || !$checkbox.length) {
          return;
        }

        $checkbox.prop("checked", false).removeClass("green");
        if ($hidden.length) {
          $hidden.val("false");
        }

        $toggle
          .off("click")
          .on("click.gaEventsGate", function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $checkbox.prop("checked", false).removeClass("green");
            if ($hidden.length) {
              $hidden.val("false");
            }
            subscriptions.upgrade_modal(
              e,
              false,
              message,
              "plus",
              "Triggered feature CTA – Events Streaming"
            );
          });

        $checkbox
          .off("change.gaEventsGate click.gaEventsGate")
          .on("change.gaEventsGate click.gaEventsGate", function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $(this).prop("checked", false).removeClass("green");
            if ($hidden.length) {
              $hidden.val("false");
            }
          });
      };

      gateGaEventsToggle(
        "#google-analytics-track-toggle",
        "#google-analytics-track",
        "#website-google-analytics-track",
        "stream events to Google Analytics 4"
      );
      gateGaEventsToggle(
        "#google-analytics-data-layer-toggle",
        "#google-analytics-data-layer",
        "#website-google-analytics-data-layer",
        "stream events to Google Tag Manager"
      );
    }

    if (
      [
        "free",
        "2026_personal",
        "2026_prime",
        "2024_pages",
        "2024_core",
        "2024_funnels",
      ].includes(plan_type) ||
      website_premium == "false"
    ) {
      $(".conditions-groups-create").on("click", function (event) {
        event.preventDefault();
        $("#newConditionsGroupModal").remove();

        subscriptions.upgrade_modal(
          event,
          false,
          "managed saved visitor segments",
          "pro",
          "Triggered feature CTA – Visitor Segments"
        );
      });
    }

    if ($("body").attr("data-controller") == "playbooks") {
      const category = decodeURIComponent(getUrlParameter("category"));
      console.log("category", category);

      if (
        category.indexOf("Upsell") > -1 &&
        ([
          "free",
          "2026_personal",
          "2026_prime",
          "2025_pro",
          "2024_pages",
          "2024_core",
        ].includes(plan_type) ||
          (plan_type == "2024_pro" && after_2024_deprecated) ||
          website_premium == "false")
      ) {
        setTimeout(function () {
          subscriptions.upgrade_modal(
            event,
            false,
            "launch dynamic 1-click upsell campaigns.",
            advancedFeatureUpgradePlan,
            "Triggered feature CTA – Upsells & Cross-sells",
            true
          );
        }, 500);
      }

      if (
        category.indexOf("Browse Abandonment") > -1 &&
        ([
          "free",
          "2026_personal",
          "2026_prime",
          "2025_pro",
          "2024_pages",
          "2024_core",
        ].includes(plan_type) ||
          (plan_type == "2024_pro" && after_2024_deprecated) ||
          website_premium == "false")
      ) {
        setTimeout(function () {
          subscriptions.upgrade_modal(
            event,
            false,
            "launch dynamic browse abandonment campaigns.",
            advancedFeatureUpgradePlan,
            "Triggered feature CTA – Browse Abandonment",
            true
          );
        }, 500);
      }

      if (
        category.indexOf("Cart Abandonment") > -1 &&
        ([
          "free",
          "2026_personal",
          "2026_prime",
          "2025_pro",
          "2024_pages",
          "2024_core",
        ].includes(plan_type) ||
          (plan_type == "2024_pro" && after_2024_deprecated) ||
          website_premium == "false")
      ) {
        setTimeout(function () {
          subscriptions.upgrade_modal(
            event,
            false,
            "launch dynamic cart abandonment campaigns.",
            advancedFeatureUpgradePlan,
            "Triggered feature CTA – Cart Abandonment",
            true
          );
        }, 500);
      }
    }

  }

  if (
    [
      "free",
      "2026_personal",
      "2024_pages",
      "2024_core",
    ].indexOf(plan_type) > -1 ||
    website_premium == "false"
  ) {
    $(".webhook-create").on("click", function (event) {
      event.preventDefault();

      $("#newWebhookModal").modal("hide");
      $("#newWebhookModal").remove();

      subscriptions.upgrade_modal(
        event,
        false,
        "create custom webhooks",
        "prime",
        "Triggered feature CTA – Webhooks"
      );
    });
  }

  $(
    '.pricing-table a[data-toggle="collapse"], .feature-gate a[data-toggle="collapse"]'
  ).each(function (i, a) {
    $(a)
      .off("click.pricing_table")
      .on("click.pricing_table", function () {
        $(a).parents(".panel").toggleClass("open");
      });
  });
};

feature_gates.bindIntegrationOptionGates = bindIntegrationOptionGates;

export default feature_gates;
